export default "__VITE_PUBLIC_ASSET__2b089b3b__"